<template><!-- svgo-optimised -->
<svg class="icon icon__menu" width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1 2H21" stroke="currentColor"/>
  <path d="M1 12H21" stroke="currentColor"/>
</svg>
</template>